/* eslint-disable quotes */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import TableContainer from "../../components/TableContainer";
import { DatePicker, message, Button } from "antd";
import "./styles.scss";
import { useNavigate } from "react-router-dom";
import { useLock } from "../../store/LockContext";
import API from "../../api";
import urls from "../../api/urls";
import moment from "moment";
import { commonColumn } from "./CommonColumn";

function LockedShipments({ ruleId }) {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [searchValue, setSearchValue] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [uploadLoading, setUploadLoading] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  const debounceRef = useRef(null);

  const navigate = useNavigate();
  const { lockedAwbNumberList, fetchAwbDetails, lockedAwbTotalCount } =
    useLock();

  const loadData = async (
    page = currentPage,
    limitValue = limit,
    search = searchValue,
    status = statusFilter
  ) => {
    setLoading(true);
    await fetchAwbDetails({
      page,
      limit: limitValue,
      search: search || "",
      status: status || "",
      rule_id: ruleId || "",
    });
    setLoading(false);
  };

  useEffect(() => {
    loadData(1, 20, "");
  }, [ruleId]);

  const handleSearch = (value) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      setSearchValue(value);
      setCurrentPage(1); // Reset to first page on search
      loadData(1, limit, value, statusFilter);
    }, 500);
  };

  const handleReset = () => {
    setSearchValue("");
    setStatusFilter(null);
    setCurrentPage(1);
    loadData(1, limit, "", null);
  };

  const handleStatusFilterChange = (value) => {
    setStatusFilter(value);
    setCurrentPage(1);
    loadData(1, limit, searchValue, value);
  };

  const handleStatusFilterReset = () => {
    setStatusFilter(null);
    setCurrentPage(1);
    loadData(1, limit, searchValue, null);
  };

  const itemRender = (_, type, originalElement) => {
    return originalElement;
  };

  const handleCompleteBooking = (record, type) => {
    navigate(`/not-booked/${type.toLowerCase()}/${record.awbNumber}`, {
      state: {
        retail: true,
      },
    });
  };

  const userinfo = JSON.parse(localStorage.getItem("userinfo"));

  const handleUploadPOD = async (record) => {
    try {
      setUploadLoading((prev) => ({ ...prev, [record.awbNumber]: true }));
      const response = await API.Api(
        `${urls.GET_DRS_NUMBERS}?awbNumbers=${record.awbNumber}&refId=${userinfo?.spId}`
      ).getWithAllHeaders();

      if (response.status && response.response.data.status === "success") {
        const data = response.response.data.data;
        if (data.awbsWithDrsNumber && data.awbsWithDrsNumber.length > 0) {
          const drsNumber = data.awbsWithDrsNumber[0].drsNumber;

          if (drsNumber) {
            message.success("DRS Number fetched successfully.");
            window.open(
              `/cp-drs-details/${drsNumber}?awbNumber=${record.awbNumber}`,
              "_blank"
            );
          } else {
            message.warning("Invalid DRS Number");
          }
        } else {
          message.warning("No DRS Number");
        }
      } else {
        message.error(
          response.response.data.message || "Failed to fetch DRS Details"
        );
      }
    } catch (error) {
      console.error("Upload POD Error:", error);
      message.error("Something went wrong while fetching DRS details.");
    } finally {
      setUploadLoading((prev) => ({ ...prev, [record.awbNumber]: false }));
    }
  };

  // const handleDateRangeChange = (dates) => {
  //   if (dates && dates.length === 2) {
  //     const [startDate, endDate] = dates;
  //     setDateRange({
  //       startDate: startDate,
  //       endDate: endDate,
  //     });
  //     // Currently API doesn't support dates for locked items in the provided snippet,
  //     // but keeping state if needed later or if I should pass it.
  //   } else {
  //     setDateRange({
  //       startDate: null,
  //       endDate: null,
  //     });
  //   }
  // };

  const handlePageChange = (pagination) => {
    setCurrentPage(pagination.current);
    setLimit(pagination.pageSize);
    setSelectedRowKeys([]); // Reset selection on page change
    loadData(
      pagination.current,
      pagination.pageSize,
      searchValue,
      statusFilter
    );
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleCreateDRS = (record) => {
    navigate("/drs", {
      state: {
        selectedAwbNumbers: [record.awbNumber],
      },
    });
  };

  const handleBulkCreateDRS = () => {
    navigate("/drs", {
      state: {
        selectedAwbNumbers: selectedRowKeys,
      },
    });
  };

  return (
    <div
      style={{
        border: "1px solid #eee",
        borderRadius: "5px",
        backgroundColor: "white",
        margin: "15px",
      }}
    >
      {ruleId === "LOCK_DRS_PENDING" && selectedRowKeys.length > 0 && (
        <div
          style={{
            padding: "10px 15px",
            borderBottom: "1px solid #eee",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#e6f7ff",
            gap: "10px",
          }}
        >
          <span>{selectedRowKeys.length} items selected</span>
          <Button
            type="primary"
            size="medium"
            style={{
              padding: "0 10px",
              borderRadius: "5px",
              backgroundColor: "#1890ff",
              borderColor: "#1890ff",
            }}
            onClick={handleBulkCreateDRS}
          >
            Create DRS
          </Button>
        </div>
      )}
      {ruleId === "LOCK_OUTSCAN_CP_NOT_INSCAN" && (
        <div
          style={{
            padding: "10px 15px",
            borderBottom: "1px solid #eee",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            backgroundColor: "#f6ffed",
            gap: "10px",
          }}
        >
          <Button
            type="primary"
            size="medium"
            style={{
              padding: "0 10px",
              borderRadius: "5px",
              backgroundColor: "#1890ff",
              borderColor: "#1890ff",
            }}
            onClick={() => navigate("/in-scan")}
          >
            Go To In-Scan
          </Button>
        </div>
      )}
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 15,
        }}
      >
        <DatePicker.RangePicker
          value={
            dateRange.startDate && dateRange.endDate
              ? [moment(dateRange.startDate), moment(dateRange.endDate)]
              : null
          }
          format="YYYY-MM-DD"
          onChange={handleDateRangeChange}
          style={{ width: "300px" }}
          allowClear
        />
      </div> */}
      <TableContainer
        loading={loading}
        rowKey="awbNumber"
        columns={commonColumn({
          searchValue,
          statusFilter,
          handleSearch,
          handleReset,
          handleStatusFilterChange,
          handleStatusFilterReset,
          handleCompleteBooking,
          handleUploadPOD,
          handleCreateDRS,
          uploadLoading,
          type: ruleId,
          selectedRowKeys,
        })}
        rowClassName={() => "custom-row"}
        dataSource={lockedAwbNumberList || []}
        locale={{ emptyText: "No Data Available" }}
        onChange={handlePageChange}
        pagination={{
          current: currentPage,
          pageSize: limit,
          total: lockedAwbTotalCount || 0,
          itemRender: itemRender,
          pageSizeOptions: ["20", "50", "100"],
          showSizeChanger: true,
        }}
        rowSelection={
          ruleId?.startsWith("LOCK_DRS_PENDING") ? rowSelection : null
        }
      />
    </div>
  );
}

export default LockedShipments;
